<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.BrandLogosGridSlice>());
</script>

<template>
  <Bounded
      as="section"
      y-padding="base"
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      class="pa-blg"
  >
    <div class="pa-container">
      <div v-if="slice.primary.kicker" class="pa-blg__kicker">
        {{ slice.primary.kicker }}
      </div>
      <div class="pa-blg__headline">
        <PrismicRichText :field="slice.primary.headline" />
      </div>
      <div class="pa-blg__grid">
        <div
            v-for="(item, index) in slice.primary.logos"
            :key="index"
            class="pa-blg__logo"
        >
          <PrismicImage
              v-if="item.logo_image?.url"
              :field="item.logo_image"
              class="pa-blg__logo-image"
          />
        </div>
      </div>
    </div>
  </Bounded>
</template>
